"use strict";

var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(object, property, receiver) { var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc && desc.writable) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _inherits = function (subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; };

var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };

var noopStorage = require("./noopStorage");
var StateSource = require("../stateSource");

var SessionStorageStateSource = (function (_StateSource) {
  function SessionStorageStateSource(options) {
    _classCallCheck(this, SessionStorageStateSource);

    _get(Object.getPrototypeOf(SessionStorageStateSource.prototype), "constructor", this).call(this, options);
    this._isSessionStorageStateSource = true;
    this.storage = typeof window === "undefined" ? noopStorage : window.sessionStorage;
  }

  _inherits(SessionStorageStateSource, _StateSource);

  _createClass(SessionStorageStateSource, {
    get: {
      value: function get(key) {
        return this.storage.getItem(getNamespacedKey(this, key));
      }
    },
    set: {
      value: function set(key, value) {
        return this.storage.setItem(getNamespacedKey(this, key), value);
      }
    }
  }, {
    defaultNamespace: {
      get: function () {
        return "";
      }
    }
  });

  return SessionStorageStateSource;
})(StateSource);

function getNamespacedKey(source, key) {
  return getNamespace(source) + key;
}

function getNamespace(source) {
  return source.namespace || SessionStorageStateSource.defaultNamespace;
}

module.exports = SessionStorageStateSource;


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty/dist/node/lib/stateSource/inbuilt/sessionStorage.js
 ** module id = 498
 ** module chunks = 0
 **/